import { CommonModule }    from '@angular/common';
import { FormsModule }     from '@angular/forms';
import { NgModule }        from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import {
  NgbModalModule,
  NgbProgressbarModule,
  NgbTooltipModule
} from '@ng-bootstrap/ng-bootstrap';

import { ControlClearerComponent }      from './control-clearer/control-clearer.component';
import { CopyToClipboardDirective }     from './copy-to-clipboard/copy-to-clipboard.component';
import { DropdownComponent }            from './dropdown/dropdown.component';
import { FlipperComponent }             from './flipper/flipper.component';
import { FormSubmitValidatorDirective } from './form-submit.validator.directive';
import { IconComponent }                from './icon/icon.component';
import { ImageViewModule }              from './image-viewer/image-viewer.module';
import { ListBoxComponent }             from './list-box/list-box.component';
import { NotificationComponent }        from './notification/notification.component';
import { PagerComponent }               from './pager/pager.component';
import { SecretKeysComponent }          from './secret-keys/secret-keys.component';
import { StatCardComponent }            from './stat-card/stat-card.component';
import { TabBarComponent }              from './tab-bar/tab-bar.component';
import { TooltipDirective }             from './tooltip/tooltip.directive';
import { WizardComponent }              from './wizard/wizard.component';
import { WizardStepComponent }          from './wizard/wizard.step.component';

@NgModule({
  declarations: [
    ControlClearerComponent,
    CopyToClipboardDirective,
    DropdownComponent,
    FlipperComponent,
    FormSubmitValidatorDirective,
    IconComponent,
    ListBoxComponent,
    NotificationComponent,
    PagerComponent,
    SecretKeysComponent,
    StatCardComponent,
    TabBarComponent,
    TooltipDirective,
    WizardComponent,
    WizardStepComponent
  ],
  entryComponents: [
    ControlClearerComponent,
    CopyToClipboardDirective,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    SecretKeysComponent,
    WizardComponent,
    WizardStepComponent
  ],
  exports: [
    // Third Party
    CommonModule,
    FormsModule,
    NgbTooltipModule,

    // Custom
    ControlClearerComponent,
    CopyToClipboardDirective,
    DropdownComponent,
    FlipperComponent,
    FormSubmitValidatorDirective,
    IconComponent,
    ImageViewModule,
    ListBoxComponent,
    NotificationComponent,
    PagerComponent,
    SecretKeysComponent,
    StatCardComponent,
    TabBarComponent,
    TooltipDirective,
    WizardComponent,
    WizardStepComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    //Third Party
    NgbModalModule,
    NgbProgressbarModule,
    NgbTooltipModule,
    TranslateModule,

    //Custom
    ImageViewModule
  ]
})
export class ComponentsModule {}
